"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      transitions = _ref.transitions;
  return {
    card: {
      position: 'relative',
      overflow: 'initial',
      border: '2px solid #fff'
    },
    clickable: {
      cursor: 'pointer'
    },
    active: {
      border: "2px solid ".concat(palette.secondary.main)
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: transitions.create('transform', {
        duration: transitions.duration.shortest
      }),
      color: palette.link.main
    },
    expandOpen: {
      transform: 'rotate(180deg)'
    },
    cardActions: {
      padding: 0
    },
    iconWrapper: {
      backgroundColor: palette.common.white,
      position: 'absolute',
      right: -8,
      top: -6,
      width: 20,
      height: 20,
      zIndex: 1,
      borderRadius: '50%'
    },
    checkIcon: {
      width: '100%',
      height: '100%',
      color: palette.link.main
    }
  };
});

var FoldableCard = function FoldableCard(_ref2) {
  var _classNames;

  var summaryComponent = _ref2.summaryComponent,
      children = _ref2.children,
      _ref2$isActive = _ref2.isActive,
      isActive = _ref2$isActive === void 0 ? false : _ref2$isActive,
      onClick = _ref2.onClick;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var handleClickShowMore = (0, _react.useCallback)(function (ev) {
    setIsExpanded(!isExpanded);
    ev.stopPropagation();
  }, [isExpanded]);
  return /*#__PURE__*/_react["default"].createElement(_material.Card, {
    onClick: onClick,
    classes: {
      root: (0, _classnames["default"])(classes.card, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, classes.active, isActive), (0, _defineProperty2["default"])(_classNames, classes.clickable, onClick), _classNames))
    },
    "data-testid": "Card"
  }, /*#__PURE__*/_react["default"].createElement(_material.CardContent, null, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: true
  }, summaryComponent), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_material.CardActions, {
    disableSpacing: true,
    classes: {
      root: classes.cardActions
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    className: (0, _classnames["default"])(classes.expand, (0, _defineProperty2["default"])({}, classes.expandOpen, isExpanded)),
    onClick: handleClickShowMore,
    "aria-expanded": isExpanded,
    "aria-label": "show more",
    "data-testid": "Card.ToggleButton",
    size: "large"
  }, /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)))))), /*#__PURE__*/_react["default"].createElement(_material.Collapse, {
    "in": isExpanded,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/_react["default"].createElement(_material.CardContent, null, children)));
};

var _default = /*#__PURE__*/(0, _react.memo)(FoldableCard);

exports["default"] = _default;